import { useEffect } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { useHelmet } from '@thd-nucleus/thd-helmet';
import { useDataModel } from '@thd-nucleus/data-sources';
import { HD_URL } from '../../constants';
import { generateTags } from '../../utils/generate-tags';
import { collectionModel } from '../../models';
import { generateCollectionDesc, generateCollectionTitle, getCategory } from './collection-metadata-helpers';

const collectionHandler = ({ data }) => {
  const { collection } = data || {};
  const { metadata, taxonomy } = collection || {};
  const { breadCrumbs } = taxonomy || {};
  const { type, brandName = 'Shop By Room', name = '', canonicalUrl } = metadata || {};
  const canonical = canonicalUrl ? `${HD_URL}${canonicalUrl}` : '';

  const category = getCategory({ breadCrumbs });
  const SEOTitle = generateCollectionTitle({ brandName, category, name, type });
  const SEODescription = generateCollectionDesc({ category, name });

  const tags = generateTags({
    canonical,
    description: SEODescription,
    ogDescription: SEODescription,
    ogTitle: SEOTitle,
    ogUrl: canonical,
    title: SEOTitle
  });

  return tags;
};

export const CollectionMetadata = ({
  collectionId
}) => {

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('collection-metadata.ready');
  }, []);

  const collectionDetailOptions = {
    variables: {
      collectionId
    }
  };

  const { data } = useDataModel('collection', collectionDetailOptions);
  const props = { collectionId };

  useHelmet('collectionMetadata', { data, props, skipCleanup: true }, collectionHandler, [collectionId]);
  return null;
};

CollectionMetadata.displayName = 'CollectionMetadata';

CollectionMetadata.dataModel = collectionModel;

CollectionMetadata.propTypes = {
  collectionId: string.isRequired
};
